// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__9MKfF","file":"styles_file__LmDIg"};